import styled from 'styled-components';


export  const Container = styled.div`

    width: 100%;
    min-width: 600px;

    height: 100vh;


    display:flex;
    flex-direction: column;




`;